// extracted by css-extract-rspack-plugin
export default {"ctrlColorPreview":"ctrlColorPreview-tI7Src","ctrlColorPreview_size_s":"ctrlColorPreview_size_s-lPQpvx","ctrlColorPreviewSizeS":"ctrlColorPreview_size_s-lPQpvx"};